<template>
  <v-content class>
    <v-toolbar class="elevation-0">
      <v-toolbar-title>Log de Ações</v-toolbar-title>
    </v-toolbar>
    <v-list style="height: auto !important;">
      <v-list-tile v-for="(logsItem, index) in logs" style="height: auto !important;">
        <v-list-tile-content
          class="mt-0 pt-0"
          style="height: auto !important;"
        >{{ index + 1 }} - {{ logsItem }}</v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-content>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    logs: {
      type: Array,
      default: []
    }
  }
};
</script>
<style scoped>
.flex {
  padding: 3px 16px;
}
.noDataSlot {
  font-size: 1em;
  padding: 10px;
}
</style>